export default {
    title: "shoph5",
    baseUrl: {
        dev: "https://hugme-scrm.69dp.cn/",//开发的时候后台接口的地址
        pro: "https://hugme-scrm.69dp.cn/"//上线产品发布之后，后台接口的地址
    }
}
